// Libraries
import I18n from 'i18next'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React, { Component } from 'react'
import { Button, Form, Icon, Input, Radio, Select, Steps, Switch } from 'antd'
import {
  cloneDeep,
  defaultTo,
  find,
  forEach,
  get,
  isEmpty,
  isNil,
  map
} from 'lodash'

// Components
import { Container } from 'Components/Modals'

// Styles
import './SignatureModal.less'

// Helper
import { createFormFields } from 'Helpers'
import RadioGroup from 'antd/es/radio/group'
import Dragger from 'antd/es/upload/Dragger'
import SignatureCanvas from 'react-signature-canvas'
import Text from 'antd/es/typography/Text'

const { Item: FormItem } = Form
const { Step } = Steps

// Sauvegarde du formulaire en temps rÃ©el
// Permet de conserver les valeurs si le composant est re-render
let UNSAVED_FORM = {}

class SignatureModal extends Component {
  static propTypes = {
    // Labels et titres
    title: PropTypes.object,
    okText: PropTypes.object,
    cancelText: PropTypes.object,

    // ContrÃ´le d'Ã©tat de la modale
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    visible: PropTypes.bool,
    loading: PropTypes.bool,

    // Contenu de la modale
    data: PropTypes.object,
    form: PropTypes.object,
    currentTab: PropTypes.string,
    openedModal: PropTypes.string,

    // Fonctions de callback
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func
  }

  static defaultProps = {
    // Actions d'API
    actions: {},

    // Labels et titres
    title: {
      single: 'pages.permits.modal.signature.single.title',
      multiple: 'pages.permits.modal.signature.multiple.title'
    },
    okText: {
      single: 'pages.permits.modal.signature.single.okText',
      multiple: 'pages.permits.modal.signature.multiple.okText'
    },
    cancelText: {
      single: 'pages.permits.modal.signature.single.cancelText',
      multiple: 'pages.permits.modal.signature.multiple.cancelText'
    },

    // ContrÃ´le d'Ã©tat de la modale
    width: 520,
    visible: false,
    loading: true,

    // Contenu de la modal
    data: {},
    form: {},
    currentTab: '',
    openedModal: '',

    // Fonctions de callback
    onCancel: () => {},
    onSubmit: () => {}
  }

  constructor(props) {
    super(props)
    this.sigCanvas1 = React.createRef()
    this.sigCanvas2 = React.createRef()

    this.sigCanvasController = React.createRef()
    this.useSavedSignatureSupervisor = true
    this.useBackupSignatureCompany = false


    // Ãtats initiaux
    this.state = {
      step: 0,
      method: 3
    }
  }

  handleChangeUseSignedSignature = e => {
    this.useSavedSignatureSupervisor = !this.useSavedSignatureSupervisor
  }


  handleChangeBackupSignature = e => {
    this.useBackupSignatureCompany = !this.useBackupSignatureCompany
  }


  handleCancel = e => {
    const { onCancel, form } = this.props
    this.setState({
      step: 0,
      method: 3,
      showInvalid: false,
    })

    // Reset du formulaire
    form.resetFields()
    UNSAVED_FORM = {}

    onCancel(e)
  }

  /**
   * Envoi du formulaire
   */
  handleSubmit = e => {
    e.preventDefault()
    const { data, onSubmit, form } = this.props
    const pad1result = this.sigCanvas1.current?.toDataURL()
    const pad2result = this.sigCanvas2.current?.toDataURL()

    let option

    form.validateFields((error, formData) => {
      if (
        (this.state.method === 1 &&
          (this.useSavedSignatureSupervisor ||
            !this.sigCanvas1.current.isEmpty())) ||
            (this.useBackupSignatureCompany && !this.sigCanvas2.current.isEmpty())
            ||
        (this.state.method === 2 &&
          (this.useSavedSignatureSupervisor ||
            !this.sigCanvas1.current.isEmpty())) ||
        this.state.method === 3
      ) {

        if (!error) {
          switch (this.state.method) {
            case 1:
              formData.supervisorSign = pad1result
              formData.companyLeaderSign = pad2result

              option = 'sign_now'
              break
            case 2:
              formData.supervisorSign = pad1result
              option = 'send_mail'
              break
            default:
              option = 'upload'
              break
          }

          // HERE ?
          // Retourner les parametres de modal au defaut
          // this.setState({
          //   step: 0,
          //   method: 3
          // })

          this.useSavedSignatureSupervisor = true
          this.useBackupSignatureCompany = false

          // onChange(formData, data, option).then(() => (UNSAVED_FORM = {}))
          onSubmit(formData, data, option)
            .then(() => {
              UNSAVED_FORM = {}

              this.setState({
                step: 0,
                method: 3
              })

              // NOTE: Never used clearing the canvas, but maybe usefull ?
              // this.sigCanvas1.current.clear()
              // this.sigCanvas2.current.clear()

              this.setState({ showInvalid: false })
            })
            .catch(error => {
              console.log('handleSubmit onSubmit error', error)
            })
        }
      } else {
        this.setState({ showInvalid: true })
      }
    })
  }

  /**
   * Rendu de la zone de boutons
   */
  renderFooter = () => {
    const { loading, okText, cancelText } = this.props

    // RÃ©cupÃ©ration du mode en cours
    // multiple || single
    const mode = defaultTo(get(this.props, 'mode'), 'single')

    // Validation du formulaire
    return (
      <div className='signature-modal-footer'>
        {this.state.step > 0 && (
          <Button
            key='previous'
            onClick={() => this.setState({ step: this.state.step - 1 })}
          >
            {I18n.t(`common.previous`)}
          </Button>
        )}
        {/* Boutons classiques (annuler, continuer ...) */}
        <div className='signature-modal-footer-controls'>
          <Button key='back' onClick={this.handleCancel}>
            {I18n.t(get(cancelText, mode))}
          </Button>

          {this.state.step < 1 && (
            <Button
              key='next'
              onClick={() => this.setState({ step: this.state.step + 1 })}
            >
              {I18n.t(`common.next`)}
            </Button>
          )}
          {this.state.step >= 1 && (
            <Button
              key='submit'
              type='primary'
              loading={loading}
              onClick={this.handleSubmit}
            >
              {I18n.t(get(okText, mode))}
            </Button>
          )}
        </div>
      </div>
    )
  }

  render() {
    const {
      form,
      data,
      width,
      title,
      okText,
      loading,
      visible,
      cancelText,
      currentTab,
      openedModal
    } = this.props
    const { getFieldDecorator } = form

    let permit

    switch (openedModal) {
      case 'signFirePermit':
        permit = find(data.firePermits, ['id', currentTab])
        break
      case 'signCapacityPermit':
        permit = find(data.capacityPermits, ['id', currentTab])
        break
      case 'signCleaningPermit':
        permit = find(data.cleaningPermits, ['id', currentTab])
        break
      case 'signSearchPermit':
        permit = find(data.searchPermits, ['id', currentTab])
        break
      default:
        permit = data
        break
    }

    // RÃ©cupÃ©ration du mode en cours
    // multiple || single
    const mode = defaultTo(get(this.props, 'mode'), 'single')
    const employees = defaultTo(get(permit.company, 'employees'), [])
    const companyLeader = defaultTo(get(permit, 'companyLeader'), {})
    const defaultCompanyLeaderEmail = defaultTo(
      get(permit, 'companyLeader.email'),
      ''
    )
    const defaultSDLPEmail = data.defaultSignerEmail

    return (
      <Container
        title={I18n.t(get(title, mode))}
        loading={loading}
        visible={visible}
        cancelText={I18n.t(get(cancelText, mode))}
        okText={I18n.t(get(okText, mode))}
        onOk={this.handleSubmit}
        onCancel={this.handleCancel}
        className={'modal signature-modal'}
        footer={this.renderFooter()}
        width={width}
      >
        <div>
          <Steps
            style={{ marginBottom: '20px' }}
            current={this.state.step}
            onChange={value => this.setState({ step: value })}
            size='small'
          >
            <Step
              title={I18n.t(`pages.permits.modal.signature.steps.method`)}
            />
            <Step title={I18n.t(`pages.permits.modal.signature.steps.sign`)} />
          </Steps>

          <Form onSubmit={this._handleSubmit}>
            {/* Choix de la mÃ©thode de signature */}
            <div>
              {this.state.step === 0 && (
                <FormItem>
                  {getFieldDecorator('choice', {
                    initialValue: 3
                  })(
                    <RadioGroup
                      onChange={choice =>
                        this.setState({ method: choice.target.value })
                      }
                    >
                      {permit.isFullControlled !== false && (
                        <Radio className={'radio'} value={1}>
                          {I18n.t(`pages.permits.modal.signature.choice.first`)}
                        </Radio>
                      )}
                      {permit.isFullControlled !== false && (
                        <Radio className={'radio'} value={2}>
                          {I18n.t(
                            `pages.permits.modal.signature.choice.second`
                          )}
                        </Radio>
                      )}
                      <Radio className={'radio'} value={3}>
                        {I18n.t(`pages.permits.modal.signature.choice.third`)}
                      </Radio>
                    </RadioGroup>
                  )}
                </FormItem>
              )}
            </div>

            {/* case 1 : signature sur place */}
            <div>
              {this.state.step === 1 && this.state.method === 1 && (
                <div>
                  <FormItem
                    name='savedSignature'
                    label={I18n.t(
                      `pages.permits.fields.signature.savedSignature`
                    )}
                  >
                    {getFieldDecorator('savedSignature', {
                      initialValue: this.useSavedSignatureSupervisor
                    })(
                      <Switch
                        defaultChecked
                        onChange={() => this.handleChangeUseSignedSignature()}
                      ></Switch>
                    )}
                  </FormItem>
                  <FormItem
                    label={I18n.t(`pages.permits.fields.signature.title`)}
                  >
                    {!this.useSavedSignatureSupervisor
                      ? getFieldDecorator('supervisorSign')(
                          <div className='sigPadContainer'>
                            <SignatureCanvas
                              penColor='black'
                              ref={this.sigCanvas1}
                              canvasProps={{ className: 'sigCanvas' }}
                            />
                            <Button
                              onClick={() => this.sigCanvas1.current.clear()}
                            >
                              {I18n.t(`common.clear`)}
                            </Button>
                          </div>
                        )
                      : getFieldDecorator('supervisorSign')(<div></div>)}
                  </FormItem>
                  <FormItem
                    label={I18n.t(`pages.permits.fields.signatureName.title`)}
                  >
                    {getFieldDecorator('companyLeader', {
                      initialValue: companyLeader.id,
                      rules: [
                        {
                          required: true,
                          message: I18n.t(
                            `pages.permits.fields.signatureName.requiredMessage`
                          )
                        }
                      ]
                    })(
                      <Select
                        placeholder={I18n.t(
                          `pages.permits.fields.signatureName.placeholder`
                        )}
                      >
                        {employees.map(employee => (
                          <Select.Option key={employee.id} value={employee.id}>
                            {employee.name}
                          </Select.Option>
                        ))}
                      </Select>
                      
                    )}
                  </FormItem>
                  <FormItem
                    name='backupSignature'
                    label={I18n.t(
                      `pages.permits.fields.signature.backupSignature`
                    )}
                  >
                    {getFieldDecorator('backupSignature', {
                      initialValue: this.useBackupSignatureCompany
                    })(
                      <Switch
                        checked={this.useBackupSignatureCompany}
                        onChange={() => this.handleChangeBackupSignature()}
                      ></Switch>
                    )}
                  </FormItem>
                  <FormItem
                  >
                    {this.useBackupSignatureCompany
                      ? getFieldDecorator('companyLeaderSign')(
                          <div className='sigPadContainer'>
                            <SignatureCanvas
                              penColor='black'
                              ref={this.sigCanvas2}
                              canvasProps={{ className: 'sigCanvas' }}
                            />
                            <Button
                              onClick={() => this.sigCanvas2.current.clear()}
                            >
                              {I18n.t(`common.clear`)}
                            </Button>
                          </div>
                        )
                      : getFieldDecorator('companyLeaderSign')(<div></div>)}
                  </FormItem>

                </div>
              )}
            </div>

            {/* cas 2 : signature et envoi d'un email */}
            <div>
              {this.state.step === 1 && this.state.method === 2 && (
                <div>
                  <FormItem
                    label={I18n.t(
                      `pages.permits.fields.signature.savedSignature`
                    )}
                  >
                    {getFieldDecorator('savedSignature', {
                      initialValue: this.useSavedSignatureSupervisor
                    })(
                      <Switch
                        defaultChecked
                        onChange={() => this.handleChangeUseSignedSignature()}
                      ></Switch>
                    )}
                  </FormItem>
                  <FormItem
                    label={I18n.t(`pages.permits.fields.signatureName.title`)}
                  >
                    {getFieldDecorator('companyLeader', {
                      initialValue: companyLeader.id,
                      rules: [
                        {
                          required: true,
                          message: I18n.t(
                            `pages.permits.fields.signatureName.requiredMessage`
                          )
                        }
                      ]
                    })(
                      <Select
                        placeholder={I18n.t(
                          `pages.permits.fields.signatureName.placeholder`
                        )}
                      >
                        {employees.map(employee => (
                          <Select.Option key={employee.id} value={employee.id}>
                            {employee.name}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>
                  <FormItem
                    label={I18n.t(
                      `pages.permits.fields.signatureEmail.titleCompany`
                    )}
                  >
                    {getFieldDecorator('companyLeaderMail', {
                      initialValue: defaultCompanyLeaderEmail,
                      rules: [
                        {
                          required: true,
                          message: I18n.t(
                            `pages.permits.fields.signatureEmail.requiredMessage`
                          )
                        }
                      ]
                    })(
                      <Input
                        placeholder={I18n.t(
                          `pages.permits.fields.signatureEmail.placeholder`
                        )}
                      />
                    )}
                  </FormItem>
                  <FormItem
                    label={I18n.t(
                      `pages.permits.fields.signatureEmail.titleSupervisor`
                    )}
                  >
                    {getFieldDecorator('supervisorMail', {
                      initialValue: defaultSDLPEmail,
                      rules: [
                        {
                          required: true,
                          message: I18n.t(
                            `pages.permits.fields.signatureEmail.requiredMessage`
                          )
                        }
                      ]
                    })(
                      <Input
                        placeholder={I18n.t(
                          `pages.permits.fields.signatureEmail.placeholder`
                        )}
                      />
                    )}
                  </FormItem>
                  <FormItem
                    label={I18n.t(`pages.permits.fields.signature.title`)}
                  >
                    {!this.useSavedSignatureSupervisor
                      ? getFieldDecorator('supervisorSign')(
                          <div className='sigPadContainer'>
                            <SignatureCanvas
                              penColor='black'
                              ref={this.sigCanvas1}
                              canvasProps={{ className: 'sigCanvas' }}
                            />
                            <Button
                              onClick={() => this.sigCanvas1.current.clear()}
                            >
                              {I18n.t(`common.clear`)}
                            </Button>
                          </div>
                        )
                      : getFieldDecorator('supervisorSign')(<div></div>)}
                  </FormItem>
                </div>
              )}
            </div>

            {/* cas 3 : joindre un permis signÃ© */}
            <div>
              {this.state.step === 1 && this.state.method === 3 && (
                <FormItem>
                  {getFieldDecorator('scan')(
                    <Dragger
                      name='scan'
                      beforeUpload={file => {
                        return false
                      }}
                    >
                      <p className='ant-upload-drag-icon'>
                        <Icon type='inbox' />
                      </p>
                      <p className='ant-upload-text'>
                        {I18n.t('pages.permits.fields.scan.title')}
                      </p>

                      <p className='ant-upload-hint'>
                        {I18n.t('pages.permits.fields.scan.print-hint')}
                      </p>

                      <p className='ant-upload-hint'>
                        {I18n.t('pages.permits.fields.scan.upload-hint')}
                      </p>

                      <div className='buttons'>
                        <Button key='import' icon='paper-clip' type='primary'>
                          {I18n.t('pages.permits.fields.scan.import')}
                        </Button>
                      </div>
                    </Dragger>
                  )}
                </FormItem>
              )}
            </div>
            {this.state.showInvalid && (
              <div className='signature-modal-danger'>
                <Text className='signature-modal-danger-text'>
                  {I18n.t(
                    'pages.permits.modal.signature.choice.missingSignature'
                  )}
                </Text>
              </div>
            )}
          </Form>
        </div>
      </Container>
    )
  }
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  Form.create({
    onValuesChange(props, fieldValue, fieldsValue) {
      UNSAVED_FORM = fieldsValue
    },
    mapPropsToFields(props) {
      const defaultProps = get(SignatureModal, 'defaultProps', {})
      let formData = cloneDeep(defaultTo(get(props, 'data'), defaultProps.data))

      if (!isEmpty(UNSAVED_FORM)) {
        formData = UNSAVED_FORM
      } else {
        // Formatage des donnÃ©es en fonction des formateurs donnÃ©s
        forEach(formData, (value, index) => {
          const format = get(
            find(map(get(props, 'rows')), { dataIndex: index }),
            'formField.format'
          )

          formData[index] = !isNil(format) ? format(value, formData) : value
        })
      }

      return createFormFields(Form, formData)
    }
  })(SignatureModal)
)
